import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { InfoBotsPage } from './info-bots';
// Multilenguaje
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

@NgModule({
  declarations: [
    InfoBotsPage,
  ],
  imports: [
    IonicPageModule.forChild(InfoBotsPage),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }), 
  ],
})
export class InfoBotsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/info-bots/info-bots.module.ts